import { createNotification } from 'react-redux-notify';

export const notificationTypes = {
    SUCCESS: "positive",
    ERROR: "negative",
    WARNING: "warning",
    INFO: "info"
}

export function showNotification(message, notificationType, marginBottom) {
    const options = {
        message: message,
        type: " ui " + notificationType + " message tiny",
        duration: 5000,
        canDismiss: true,
        showCloseAllBtn: true,
        customStyles: { close: "Notification__close___CZE_b ui gery header", item__message: "pr-20" }
    };

    let notify = createNotification(options);
    document.querySelector(".Notify__containerBottomRight___2LKUe").style.marginBottom = marginBottom ?? "3%";

    return notify;
}